'use client';

import { ForwardedRef, forwardRef } from 'react';
import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
import classNames from 'classnames';
import { useResponsiveness } from '@monorepo/react-hooks';

import './button.scss';

type ButtonProps = AntButtonProps & {
  ref?: ForwardedRef<HTMLButtonElement>;
  id?: string;
  dataTestId?: string;
};

export type { ButtonProps };

const Button = forwardRef<HTMLButtonElement, AntButtonProps>(
  ({ className, id, ...rest }: AntButtonProps, ref) => {
    const { isMobile } = useResponsiveness();

    return (
      <AntButton
        className={classNames(
          'the5ers-button',
          { 'the5ers-button--mobile': isMobile },
          className,
        )}
        id={id}
        {...rest}
        ref={ref}
      />
    );
  },
);

export { Button };
